import { getStoredEmbedParam } from './embedParams';
import { decodeApiBaseParam } from './apiBaseCodec';

export { decodeApiBaseParam } from './apiBaseCodec';

const DEFAULT_API_BASE = 'http://127.0.0.1:8005';

/** 静态 H5 站点端口（只提供页面，不能 POST 接口） */
const STATIC_H5_PORTS = new Set(['82', '80', '']);

function getDefaultApiBase() {
  const env = process.env.VUE_APP_API_BASE;
  if (env) {
    return String(env).trim().replace(/\/+$/, '');
  }
  return DEFAULT_API_BASE;
}

/**
 * 将误指向静态站（:82）的 apiBase 纠正为后端端口 :8005
 */
export function normalizeApiBase(base) {
  if (!base) return '';
  let normalized = decodeApiBaseParam(base).replace(/\/+$/, '');
  if (!normalized) return '';

  try {
    const withProto = /^https?:\/\//i.test(normalized)
      ? normalized
      : `http://${normalized}`;
    const u = new URL(withProto);
    const port = u.port || (u.protocol === 'https:' ? '443' : '80');

    if (STATIC_H5_PORTS.has(port) || port === '82') {
      u.port = '8005';
      return `${u.protocol}//${u.hostname}:8005`;
    }
    return `${u.protocol}//${u.host}`;
  } catch (_) {
    if (/:82(\/|$)/.test(normalized)) {
      return normalized.replace(/:82(\/|$)/, ':8005$1');
    }
    return normalized;
  }
}

/**
 * 解析后端 API 根地址（不含尾部斜杠）
 * 优先级：URL 参数 apiBase > sessionStorage > AppBridge > 默认 :8005
 * 注意：切勿使用 H5 静态站 origin（:82），否则 POST 会 405
 */
export function resolveApiBase() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('apiBase') || getStoredEmbedParam('apiBase');
    if (fromQuery) {
      const fixed = normalizeApiBase(fromQuery);
      if (fixed) return fixed;
    }
  } catch (_) {
    /* ignore */
  }

  if (window.AppBridge && typeof window.AppBridge.getApiBase === 'function') {
    try {
      const fromBridge = window.AppBridge.getApiBase();
      if (fromBridge) {
        const fixed = normalizeApiBase(fromBridge);
        if (fixed) return fixed;
      }
    } catch (_) {
      /* ignore */
    }
  }

  try {
    const { protocol, hostname, port } = window.location;
    const pagePort = port || (protocol === 'https:' ? '443' : '80');
    if (
      pagePort === '82' ||
      STATIC_H5_PORTS.has(pagePort) ||
      hostname === '127.0.0.1'
    ) {
      return getDefaultApiBase();
    }
    if (
      hostname &&
      hostname !== 'localhost' &&
      hostname !== '127.0.0.1' &&
      (protocol === 'http:' || protocol === 'https:')
    ) {
      return normalizeApiBase(`${protocol}//${hostname}:8005`);
    }
  } catch (_) {
    /* ignore */
  }

  return getDefaultApiBase();
}
